import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cN from 'classnames';
import dayjs from 'dayjs';
import { I_TourIDItem } from '@Redux/detail/Group/interfaces';
import {
    setCurrentTourID,
    setGroupAllCalendar,
    setSchedulesActive,
    // setGroupDetail,
} from '@Redux/detail/Group/actions';
// import { setItineraries } from '@Redux/detail/Itineraries/actions';
import { RootState } from '@Redux/detail/store';
import styles from '../style.module.scss';

function SchedulesList() {
    const { Schedules, GroupInfo, CalendarGroups, scheduleActive } = useSelector(
        (state: RootState) => state.groupReducer
    );
    const dispatch = useDispatch();
    const { travelinfo } = document.getElementById('detailPagePara')!.dataset!;
    const initTourID = JSON.parse(travelinfo!).GroupInfo.TourID;

    function getMonthStartAndEnd(day: string) {
        const start = dayjs(day).startOf('month').format('YYYY-MM-DD');
        const end = dayjs(day).endOf('month').format('YYYY-MM-DD');

        return [start, end];
    }

    function clickScheduleType(TourID: string, idx: number) {
        const [GoDateStart, GoDateEnd] = getMonthStartAndEnd(CalendarGroups.month);
        const isAll = idx === 0; // 行程選擇全部

        const reqBody = {
            NormGroupID: GroupInfo.NormGroupID,
            TourID: isAll ? '' : TourID,
            GoDateStart,
            GoDateEnd,
        };

        dispatch(setGroupAllCalendar(reqBody));
        dispatch(setCurrentTourID(isAll ? '' : TourID));
        dispatch(setSchedulesActive(idx));
    }

    return Schedules ? (
        <div className={styles.contentBlock}>
            <div className={styles['mobile-note']}>行程會依出發時間或景點安排而有所不同</div>
            <div
                className={cN(styles.item, scheduleActive === 0 && styles['active'])}
                onClick={() => clickScheduleType(initTourID, 0)}
            >
                全部
            </div>
            {Schedules!.TourIDList.map((item: I_TourIDItem, idx: number) => (
                <div
                    className={cN(styles.item, idx + 1 === scheduleActive && styles['active'])}
                    key={idx}
                    onClick={() => clickScheduleType(item.TourID, idx + 1)}
                    data-tourid={item.TourID}
                >
                    行程{idx + 1}
                </div>
            ))}
        </div>
    ) : null;
}

export default SchedulesList;
